<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout row justify-center>
        <v-dialog v-model="newWarehouseDialog" persistent max-width="50%">
          <v-btn slot="activator" color="primary" dark>Add A New Warehouse</v-btn>
          <v-card>
            <v-card-title>
              {{ newWarehouseDialogText }}
            </v-card-title>
            <v-card-text>
              <v-form ref="newWarehouseForm" lazy-validation>
                <v-layout row wrap justify-space-around>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.legalCharactersOnly]" v-model="newWarehouse.name" label="Warehouse Name"/>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.latLngOnly]" v-model="newWarehouse.lat" label="Latitude"/>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.latLngOnly]" v-model="newWarehouse.lng" label="Longitude"/>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="closeNewWarehouseForm">Cancel</v-btn>
              <v-btn v-show="!newWarehouseSuccess" color="green darken-1" flat @click="submitWarehouse">Submit</v-btn>
              <v-btn v-show="newWarehouseSuccess" color="green darken-1" flat @click="closeNewWarehouseForm">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="newPartDialog" persistent max-width="50%">
          <v-btn slot="activator" color="primary" dark>Add A New Part</v-btn>
          <v-card>
            <v-card-title>
              {{ newPartDialogText }}
            </v-card-title>
            <v-card-text>
              <v-form ref="newPartForm" lazy-validation>
                <v-layout row wrap justify-space-around>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.legalCharactersOnly]" v-model="newPart.name" label="Part Name"/>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.partNumberTypeOnly]" v-model="newPart.number" label="Number"/>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-select :rules="[rules.required]" v-model="newPart.serialised" :items="['Yes', 'No']" label="Serialised?"/>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="closeNewPartForm">Cancel</v-btn>
              <v-btn v-show="!newPartSuccess" color="green darken-1" flat @click="submitPart">Submit</v-btn>
              <v-btn v-show="newPartSuccess" color="green darken-1" flat @click="closeNewPartForm">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="newKitDialog" persistent max-width="50%">
          <v-btn slot="activator" color="primary" dark>Add A New Kit</v-btn>
          <v-card>
            <v-card-title>
              {{ newKitDialogText }}
            </v-card-title>
            <v-card-text>
              <v-form ref="newKitForm" lazy-validation>
                <v-layout row wrap justify-space-around>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.legalCharactersOnly]" v-model="newKit.name" label="Kit Name"/>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.partNumberTypeOnly]" v-model="newKit.prestagedKitNsumber" label="Pre-staged Kit's Part Number"/>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.partNumberTypeOnly]" v-model="newKit.emptyKitsNumber" label="Empty Kit's Part Number"/>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field :rules="[rules.required,rules.partNumbersCommaSeparatedOnly]" v-model="newKit.partsInKit" label="Part Numbers of Parts Inside Kit"/>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-select :rules="[rules.required]" v-model="newKit.serialised" :items="['Yes', 'No']" label="Serialised?"/>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="closeNewKitForm">Cancel</v-btn>
              <v-btn v-show="!newKitSuccess" color="green darken-1" flat @click="submitKit">Submit</v-btn>
              <v-btn v-show="newKitSuccess" color="green darken-1" flat @click="closeNewKitForm">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from 'axios';
import getSitePass from "../sitepass";
export default {
  name: "Admin",
  data: () => ({
    newWarehouse: {},
    newPart: {},
    newKit: {},
    newWarehouseDialog: false,
    newWarehouseDialogText: "",
    newWarehouseSuccess: false,
    newPartDialog: false,
    newPartDialogText: "",
    newPartSuccess: false,
    newKitDialog: false,
    newKitDialogText: "",
    newKitSuccess: false,
    rules: {
      required: value => !!value || 'Required.',
      // can make this stronger
      latLngOnly: value => {
        if (value === undefined) return true
        if (value.toString().match(/^[+-]?[0-9][0-9]?[0-9]?\.[0-9]{7}$/g)) return true;
        return 'Invalid Lat/Lng, must be 7dp';
      },
      legalCharactersOnly: value => {
        if (value === undefined) return true
        if (!value.toString().match(/'|\.| $|^ /g)) return true;
        return 'Invalid Name';
      },
      partNumberTypeOnly: value => {
        if (value === undefined) return true;
        if (value.toString().match(/^[1-2][0-9]{4}-[0]{2}[1-9]$/g)) return true;
        return 'Invalid Part Number';
      },
      partNumbersCommaSeparatedOnly: value => {
        if (value === undefined) return true;
        const partNumArray = value.split(',')
        for(let partNum of partNumArray) {
          if (!partNum.toString().match(/^[1-2][0-9]{4}-[0]{2}[1-9]$/g)) return 'Invalid Part Number/s';
        }
        return true
      }
    },
  }),
  methods: {
    closeNewWarehouseForm() {
      this.newWarehouseDialog = false; 
      this.newWarehouseSuccess = false;
      this.$refs.newWarehouseForm.reset();
    },
    submitWarehouse() {
      if (this.$refs.newWarehouseForm.validate()) {
        axios
          .post(`${process.env.VUE_APP_backend_url}/addWarehouseToDB?sitepass=${getSitePass()}`,
            {
              name: this.newWarehouse.name,
              lat: this.newWarehouse.lat,
              lng: this.newWarehouse.lng,
            }
          )
          .then(response => {
            if (response.status === 200) {
              this.newWarehouseDialogText = "Warehouse successfully created in ems database and google sheets. Remember to resync device magic"
              this.newWarehouseSuccess = true
            } else this.newWarehouseDialogText = "Sorry, there has been a problem proccessing you request"
          })
          .catch(error => {
            this.newWarehouseDialogText = "Sorry, there has been a problem proccessing you request";
            console.log(error);
          })
      }
    },
    closeNewPartForm() {
      this.newPartDialog = false; 
      this.newPartSuccess = false;
      this.$refs.newPartForm.reset();
    },
    submitPart() {
      if (this.$refs.newPartForm.validate()) {
        axios
          .post(`${process.env.VUE_APP_backend_url}/addPartToDB?sitepass=${getSitePass()}`,
            {
              number: this.newPart.number,
              name: this.newPart.name,
              serialised: this.newPart.serialised,
            }
          )
          .then(response => {
            if (response.status === 200) {
              this.newPartDialogText = "Part successfully created in ems database and google sheets. Remember to resync device magic"
              this.newPartSuccess = true
            } else this.newPartDialogText = "Sorry, there has been a problem proccessing you request"
          })
          .catch(error => {
            this.newPartDialogText = "Sorry, there has been a problem proccessing you request";
            console.log(error);
          })
      }
    },
    closeNewKitForm() {
      this.newKitDialog = false; 
      this.newKitSuccess = false;
      this.$refs.newKitForm.reset();
    },
    submitKit() {
      if (this.$refs.newKitForm.validate()) {
        axios
          .post(`${process.env.VUE_APP_backend_url}/addKitToDB?sitepass=${getSitePass()}`,
            {
              prestagedKitsNumber: this.newKit.prestagedKitNsumber,
              emptyKitsNumber: this.newKit.emptyKitsNumber,
              name: this.newKit.name,
              partNumsInKit: this.newKit.partsInKit,
              serialised: this.newKit.serialised
            }
          )
          .then(response => {
            if (response.status === 200) {
              this.newKitDialogText = "Part successfully created in ems database and google sheets. Remember to resync device magic"
              this.newKitSuccess = true
            } else this.newKitDialogText = "Sorry, there has been a problem proccessing you request"
          })
          .catch(error => {
            this.newKitDialogText = "Sorry, there has been a problem proccessing you request";
            console.log(error);
          })
      }
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/adminView.vue